export enum CRUD {
    CREATE,
    READ,
    UPDATE,
    DELETE,
    NONE
}
